import { IThemeSelector } from './theme-selector-interface';

export class ThemeSelector implements IThemeSelector {
  public colorTheme: string;

  public constructor(colorTheme: string) {
    this.colorTheme = colorTheme;
  }
}
